// store/menuSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isOpen: false,
  translate: '-100vw,0,0',
};

const menuSlice = createSlice({
  name: 'menu',
  initialState,
  reducers: {
    openMenu: (state) => {
      state.isOpen = true;
      state.translate = '0,0,0';
    },
    closeMenu: (state) => {
      state.isOpen = false;
      state.translate = '-100vw,0,0';
    },
    toggleMenu: (state) => {
      state.isOpen = !state.isOpen;
      state.translate = state.isOpen ? '0,0,0' : '-100vw,0,0';
    },
  },
});

export const { openMenu, closeMenu, toggleMenu } = menuSlice.actions;
export default menuSlice.reducer;
